import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default class HeaderBar extends React.PureComponent {
  static propTypes = {
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    className: PropTypes.string,
    textClassName: PropTypes.string,
  }

  get classNames() {
    const { className } = this.props;
    return classNames('header-bar flex justify-space-between padding-left-15 padding-right-15 height-50', {
      [className]: className,
    })
  }

  get textClassNames() {
    const { textClassName } = this.props;
    return classNames('', {
      [textClassName]: textClassName,
    })
  }

  render() {
    const { text, children } = this.props;

    return (
      <div className={this.classNames}>
        <div className={this.textClassNames}>{text}&nbsp;</div>
        <div className='right'>{children}</div>
      </div>
    );
  }
}